<template>
  <component :is="_elTag" class="el-radio-group" role="radiogroup" @keydown="handleKeydown">
    <template v-if="radioType == 'radio-button'">
      <el-radio-button v-for="(item, index) in defaultData" :key="`${index}-${item.value}`" :label="item.value" :disabled="item.disabled">
        {{ item.label }}
      </el-radio-button>

    </template>
    <template v-else>
      <el-radio v-for="(item, index) in defaultData" :key="`${index}-${item.value}`" :label="item.value" :disabled="item.disabled">
        {{ item.label }}
      </el-radio>
    </template>

  </component>
</template>

<script>
import { RadioGroup, RadioButton, Radio } from 'element-ui'

export default {
  name: 'WkRadioGroup',
  extends: RadioGroup,
  props: {
    defaultData: {
      type: Array,
      default: () => []
    },
    radioType: {
      type: String,
      default: 'radio-button'
    }
  },
}
</script>
<style lang="scss" scoped></style>
